<template>
  <div>
    <li v-if="/https?:\/\//.test(link)">
      <a :href="link" target="_blank" rel="noopener noreferrer">{{ name }}</a
      ><v-icon dark small>{{iconLaunch}}</v-icon>
    </li>
    <router-link v-else :to="link" tag="li"
      >{{ name }} <v-icon dark small>{{iconLaunch}}</v-icon></router-link
    >
  </div>
</template>

<script>
import { mdiLaunch } from '@mdi/js'

export default {
  name: "sourceLinkList",
  props: {
    link: { type: [String], default: "" },
    name: { type: [String], default: "" },
  },
  data: () => ({
    iconLaunch: mdiLaunch
  }),
  computed: {},
  mounted: function() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  padding-left: 1em;
  text-indent: -1em;
}
li,
a:link,
a:visited {
  color: #909090;
}
li:hover,
li.router-link-active,
li.router-link-exact-active,
a:hover {
  cursor: pointer;
  color: #ffffff;
}
</style>
